export const movies = [
  {
    id: "deep-sea-echo",
    title: "深海回声",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    genres: ["科幻", "悬疑", "冒险"],
    director: "陆沉舟",
    actors: ["江屿", "苏晚吟", "周牧野", "林知夏"],
    duration: "128 分钟",
    updatedAt: "2024-11-18",
    popularity: 9820,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20lone%20deep%20sea%20diver%20silhouette%20descending%20into%20a%20dark%20ocean%20trench%20surrounded%20by%20bioluminescent%20creatures%2C%20dramatic%20underwater%20lighting%2C%20deep%20teal%20and%20navy%20tones%20with%20warm%20orange%20accent%2C%20minimalist%20composition%2C%20moody%20atmosphere&width=400&height=600&seq=mv-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20underwater%20scenery%20of%20a%20deep%20ocean%20trench%20with%20glowing%20bioluminescent%20particles%2C%20shafts%20of%20light%20piercing%20the%20water%2C%20dark%20navy%20and%20teal%20tones%20with%20subtle%20orange%20glow%2C%20atmospheric%20and%20mysterious%2C%20high%20detail&width=1600&height=900&seq=mv-01-bd&orientation=landscape",
    tagline: "有些秘密，沉在比黑暗更深的地方。",
    description:
      "一支深海科考队在马里亚纳海沟执行例行勘探时，意外接收到一段无法解释的低频信号。随着下潜深度不断增加，队员们开始听见彼此内心最不愿面对的回忆。当科学无法解释一切，他们必须决定是继续下潜，还是带着秘密返回海面。"
  },
  {
    id: "kyoto-mist",
    title: "京都迷雾",
    type: "电影",
    region: "日本",
    year: 2023,
    rating: 8.2,
    genres: ["剧情", "悬疑", "文艺"],
    director: "森川遥",
    actors: ["高桥凛", "中村悠真", "小林幸子"],
    duration: "116 分钟",
    updatedAt: "2024-10-02",
    popularity: 7640,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20misty%20old%20Kyoto%20street%20at%20dawn%20with%20a%20lone%20figure%20holding%20an%20umbrella%2C%20wooden%20townhouses%20fading%20into%20fog%2C%20muted%20teal%20and%20navy%20palette%20with%20a%20warm%20lantern%20accent%2C%20quiet%20melancholic%20mood%2C%20high%20detail&width=400&height=600&seq=mv-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20a%20foggy%20traditional%20Japanese%20district%20at%20dusk%2C%20stone%20lanterns%20and%20wooden%20architecture%20dissolving%20into%20layered%20mist%2C%20deep%20blue%20and%20grey%20tones%20with%20a%20single%20warm%20light%2C%20tranquil%20and%20atmospheric&width=1600&height=900&seq=mv-02-bd&orientation=landscape",
    tagline: "雾散之前，谁都不敢说自己看清了真相。",
    description:
      "一位整理旧宅遗物的作家，在京都老宅中发现了一叠没有寄出的信。信封上的地址指向一座早已不存在的茶屋。他循着线索走访邻里的老人，逐渐拼凑出一段被时间掩埋的往事，也发现自己的家族与真相之间，隔着一层永远散不去的雾。"
  },
  {
    id: "sea-of-stars",
    title: "星海纪年",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 9.1,
    genres: ["科幻", "剧情", "史诗"],
    director: "顾长风",
    actors: ["叶知秋", "沈砚", "温以宁", "程亦舟"],
    duration: "45 分钟 / 集",
    episodes: 36,
    updatedAt: "2024-12-01",
    popularity: 10240,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20poster%20of%20an%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%20with%20a%20vast%20colorful%20nebula%2C%20deep%20navy%20space%20backdrop%20with%20orange%20and%20teal%20highlights%2C%20epic%20scale%2C%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=mv-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20space%20scene%20of%20a%20massive%20ringed%20planet%20with%20a%20fleet%20of%20starships%2C%20swirling%20nebula%20and%20distant%20stars%2C%20deep%20navy%20and%20indigo%20tones%20with%20warm%20orange%20glow%2C%20epic%20and%20awe%20inspiring&width=1600&height=900&seq=mv-03-bd&orientation=landscape",
    tagline: "人类迈出的一小步，需要一整个世纪来偿还。",
    description:
      "公元 2189 年，第一艘载人星际方舟「纪年号」驶离太阳系，踏上寻找新家园的百年航程。三代船员在封闭的飞船中繁衍生息，逐渐忘记了地球的模样。当年轻的导航员在一次观测中发现了回家的航线，一个关于牺牲、传承与希望的史诗故事就此展开。"
  },
  {
    id: "end-of-long-night",
    title: "长夜将尽",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    genres: ["悬疑", "犯罪", "剧情"],
    director: "韩江雪",
    actors: ["裴今朝", "柳无眠", "孟晏清", "谢云归"],
    duration: "50 分钟 / 集",
    episodes: 24,
    updatedAt: "2024-11-28",
    popularity: 9110,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20a%20detective%20silhouette%20under%20a%20flickering%20streetlamp%2C%20wet%20asphalt%20reflections%2C%20dark%20navy%20and%20grey%20tones%20with%20an%20orange%20glow%2C%20tense%20mood&width=400&height=600&seq=mv-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20noir%20cityscape%20at%20midnight%20in%20heavy%20rain%2C%20towering%20buildings%20with%20scattered%20window%20lights%2C%20reflective%20wet%20streets%2C%20deep%20blue%20and%20black%20tones%20with%20distant%20orange%20lamps%2C%20brooding%20atmosphere&width=1600&height=900&seq=mv-04-bd&orientation=landscape",
    tagline: "黑夜最长的时刻，往往是黎明前。",
    description:
      "一桩尘封十二年的悬案重新浮出水面，牵出当年办案警探与受害者家属之间错综复杂的联系。新老两代刑警在追查中不断触碰真相的边界，也触碰彼此心底最深的伤口。当长夜终于走到尽头，他们才发现，答案早已写在那些被忽略的细节里。"
  },
  {
    id: "mountains-and-seas",
    title: "山海拾遗录",
    type: "动漫",
    region: "中国大陆",
    year: 2024,
    rating: 9.3,
    genres: ["奇幻", "国风", "冒险"],
    director: "白墨",
    actors: ["配音：云舒", "配音：慕辰", "配音：青禾"],
    duration: "24 分钟 / 集",
    episodes: 26,
    updatedAt: "2024-12-05",
    popularity: 10580,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20eastern%20fantasy%20poster%20of%20ancient%20mythical%20mountains%20and%20sea%20creatures%20with%20a%20young%20traveler%20holding%20a%20scroll%2C%20ink%20painting%20inspired%20composition%2C%20deep%20navy%20and%20jade%20teal%20palette%20with%20a%20warm%20orange%20sun%2C%20high%20detail&width=400&height=600&seq=mv-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20eastern%20fantasy%20landscape%20of%20floating%20mythical%20mountains%20above%20a%20sea%20of%20clouds%2C%20flying%20cranes%20and%20ancient%20architecture%2C%20deep%20navy%20and%20jade%20tones%20with%20golden%20orange%20light%2C%20ethereal%20ink%20painting%20style&width=1600&height=900&seq=mv-05-bd&orientation=landscape",
    tagline: "每一只异兽，都记得一个被遗忘的名字。",
    description:
      "少年阿拾在一次意外中获得了能听懂山川草木之声的古老血脉，从此踏上重绘《山海经》未竟之卷的旅程。他走过云海浮山、深海龙宫与荒漠古城，收集散落人间的异兽传说。每记录一段故事，就有一份被遗忘的记忆重新回到世间。"
  },
  {
    id: "city-fireworks",
    title: "城市烟火",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    rating: 7.9,
    genres: ["都市", "情感", "生活"],
    director: "徐嘉禾",
    actors: ["方晴", "许南舟", "唐棠"],
    duration: "40 分钟 / 集",
    episodes: 30,
    updatedAt: "2024-09-16",
    popularity: 6830,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20slice%20of%20life%20poster%20of%20warm%20city%20rooftops%20at%20dusk%20with%20string%20lights%20and%20neighbors%20gathering%2C%20cozy%20urban%20life%2C%20deep%20navy%20and%20teal%20tones%20with%20abundant%20warm%20orange%20lights%2C%20comforting%20mood&width=400&height=600&seq=mv-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20a%20warm%20lived%20in%20city%20neighborhood%20at%20dusk%2C%20rooftop%20gatherings%20and%20lit%20windows%2C%20deep%20blue%20evening%20sky%20with%20glowing%20orange%20lights%2C%20cozy%20nostalgic%20atmosphere&width=1600&height=900&seq=mv-06-bd&orientation=landscape",
    tagline: "再大的城市，也需要有人点亮一盏灯。",
    description:
      "故事围绕一栋老旧居民楼里的几位邻居展开：开深夜食堂的老板娘、总在加班的程序员、刚搬来的独居老人、还有为梦想奔波的小演员。他们的生活琐碎而真实，在一次次相遇与告别之间，把冰冷的城市慢慢焐热成了家。"
  },
  {
    id: "chaser",
    title: "追风者",
    type: "电影",
    region: "中国香港",
    year: 2024,
    rating: 8.4,
    genres: ["动作", "冒险", "赛车"],
    director: "雷震霆",
    actors: ["聂风", "柯一诺", "谷雨"],
    duration: "121 分钟",
    updatedAt: "2024-11-05",
    popularity: 8120,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20action%20poster%20of%20a%20motorcycle%20rider%20speeding%20along%20a%20winding%20coastal%20mountain%20road%20with%20motion%20blur%2C%20dramatic%20sky%2C%20deep%20navy%20and%20teal%20tones%20with%20a%20hot%20orange%20sun%20accent%2C%20high%20energy&width=400&height=600&seq=mv-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20coastal%20highway%20curving%20along%20cliffs%20at%20golden%20hour%20with%20a%20speeding%20rider%2C%20ocean%20below%20and%20dramatic%20clouds%2C%20deep%20blue%20and%20teal%20tones%20with%20warm%20orange%20sunlight%2C%20dynamic&width=1600&height=900&seq=mv-07-bd&orientation=landscape",
    tagline: "风从来不会等你，但会记得每一个追上它的人。",
    description:
      "退役赛车手阿风为了替昔日队友完成未竟的比赛，重新跨上机车，挑战被誉为「死亡弯道」的环海公路赛。对手是天赋异禀的年轻车神，而他要战胜的，其实是自己三年前那场事故留下的阴影。速度与救赎，在同一条赛道上相遇。"
  },
  {
    id: "silent-testimony",
    title: "沉默的证词",
    type: "电视剧",
    region: "韩国",
    year: 2023,
    rating: 8.6,
    genres: ["犯罪", "悬疑", "法庭"],
    director: "朴叙俊",
    actors: ["李在勋", "金秀雅", "车太贤"],
    duration: "60 分钟 / 集",
    episodes: 16,
    updatedAt: "2024-08-20",
    popularity: 7990,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20legal%20thriller%20poster%20of%20a%20dim%20interrogation%20room%20lit%20by%20a%20single%20hanging%20lamp%2C%20empty%20chair%20and%20a%20stack%20of%20case%20files%2C%20deep%20navy%20and%20grey%20tones%20with%20a%20cold%20orange%20glow%2C%20tense%20mood&width=400&height=600&seq=mv-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20empty%20courtroom%20at%20night%20with%20a%20single%20spotlight%20on%20the%20witness%20stand%2C%20rows%20of%20empty%20seats%2C%20deep%20blue%20and%20charcoal%20tones%20with%20a%20warm%20lamp%20glow%2C%20solemn%20atmosphere&width=1600&height=900&seq=mv-08-bd&orientation=landscape",
    tagline: "没有人开口，但真相从未沉默。",
    description:
      "一名以「从不败诉」著称的检察官，接手了一桩所有人都劝他放弃的旧案。关键证人当庭翻供，证据链轰然断裂，而唯一的突破口，是一段无人注意的现场录音。在权力与良知的较量中，他要让沉默的证词重新开口说话。"
  },
  {
    id: "time-post-office",
    title: "时光邮局",
    type: "电影",
    region: "中国大陆",
    year: 2022,
    rating: 8.1,
    genres: ["爱情", "奇幻", "治愈"],
    director: "沈念之",
    actors: ["顾青梧", "白鹭", "陆时安"],
    duration: "109 分钟",
    updatedAt: "2024-07-11",
    popularity: 7120,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20fantasy%20poster%20of%20a%20vintage%20post%20office%20with%20floating%20glowing%20letters%20and%20a%20grand%20clock%2C%20nostalgic%20warm%20light%2C%20deep%20navy%20and%20teal%20tones%20with%20rich%20orange%20gold%20accents%2C%20dreamy%20mood&width=400&height=600&seq=mv-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20dreamlike%20vintage%20post%20office%20interior%20filled%20with%20floating%20glowing%20letters%20and%20dust%20motes%20in%20warm%20sunlight%2C%20deep%20blue%20shadows%20with%20golden%20orange%20highlights%2C%20whimsical%20romantic%20atmosphere&width=1600&height=900&seq=mv-09-bd&orientation=landscape",
    tagline: "寄给未来的信，总有一天会送到。",
    description:
      "小镇上有一间传说能寄信到过去的邮局，只有真正心有所念的人才能找到它。失意的插画师在这里寄出了一封写给五年前自己的信，却意外收到了来自未来的回信。两个时空之间的一问一答，让他重新理解了遗憾与放下的意义。"
  },
  {
    id: "wasteland-knight",
    title: "荒原骑士",
    type: "电影",
    region: "美国",
    year: 2023,
    rating: 7.8,
    genres: ["西部", "剧情", "公路"],
    director: "Ethan Cole",
    actors: ["Marcus Hale", "Ivy Brooks", "Dean Fisher"],
    duration: "134 分钟",
    updatedAt: "2024-06-28",
    popularity: 6540,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20western%20poster%20of%20a%20lone%20cowboy%20on%20horseback%20in%20a%20vast%20desert%20canyon%20at%20golden%20hour%2C%20dust%20in%20the%20air%2C%20deep%20navy%20sky%20with%20warm%20orange%20sunlight%2C%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=mv-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20desert%20canyon%20landscape%20at%20sunset%20with%20layered%20red%20rock%20formations%20and%20a%20lone%20rider%20in%20the%20distance%2C%20deep%20blue%20evening%20sky%20with%20warm%20orange%20horizon%2C%20epic%20and%20lonely&width=1600&height=900&seq=mv-10-bd&orientation=landscape",
    tagline: "荒原不会原谅任何人，但会记住每一个走过的人。",
    description:
      "一名背负过去的流浪枪手穿越荒野，只为把一封迟到的信送到故人手中。一路上他遇上形形色色的旅人：寻找矿脉的父女、逃亡的乐手、以及一名同样不愿提起往事的警长。旅途终点的答案，比荒原本身更加沉重。"
  },
  {
    id: "philosophy-of-kitchen",
    title: "厨房里的哲学",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    genres: ["美食", "真人秀", "文化"],
    director: "总导演：孙蔓",
    actors: ["常驻：陈知味", "常驻：林小满", "常驻：老周"],
    duration: "60 分钟 / 期",
    episodes: 12,
    updatedAt: "2024-11-22",
    popularity: 7260,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20food%20show%20poster%20of%20a%20warm%20modern%20kitchen%20with%20a%20chef%20elegantly%20plating%20a%20dish%20and%20rising%20steam%2C%20cozy%20lighting%2C%20deep%20navy%20and%20teal%20tones%20with%20rich%20warm%20orange%20highlights%2C%20appetizing%20and%20refined&width=400&height=600&seq=mv-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20warm%20kitchen%20scene%20of%20several%20chefs%20cooking%20together%20with%20steam%20and%20fresh%20ingredients%20on%20a%20wooden%20counter%2C%20deep%20blue%20shadows%20with%20golden%20orange%20light%2C%20inviting%20atmosphere&width=1600&height=900&seq=mv-11-bd&orientation=landscape",
    tagline: "一道菜里，藏着一整个人生。",
    description:
      "每期节目邀请一位普通人与一位大厨，用一道家常菜交换彼此的人生故事。没有紧张的比赛，也没有残酷的淘汰，只有灶台前的烟火气和慢慢聊开的心事。在锅碗瓢盆之间，讲述食物与记忆、家常与远行的温柔哲学。"
  },
  {
    id: "blue-planet-chronicle",
    title: "蓝色星球志",
    type: "纪录片",
    region: "英国",
    year: 2024,
    rating: 9.5,
    genres: ["自然", "海洋", "科普"],
    director: "Narrated by David Hartley",
    actors: ["解说：张之声"],
    duration: "55 分钟 / 集",
    episodes: 8,
    updatedAt: "2024-12-08",
    popularity: 9880,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20nature%20documentary%20poster%20of%20a%20whale%20breaching%20under%20bright%20ocean%20sunlight%20with%20splashing%20water%2C%20deep%20blue%20sea%20and%20teal%20tones%20with%20warm%20orange%20sun%20accents%2C%20majestic%20and%20clean%20composition&width=400&height=600&seq=mv-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=awe%20inspiring%20aerial%20cinematic%20view%20of%20deep%20blue%20ocean%20surface%20with%20sunlight%20shafts%20and%20a%20giant%20whale%20breaching%2C%20scattered%20sparkling%20waves%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20golden%20light%2C%20high%20detail&width=1600&height=900&seq=mv-12-bd&orientation=landscape",
    tagline: "我们脚下的星球，还有一半是未知。",
    description:
      "历时四年拍摄，横跨五大洋的海洋生态纪录片。镜头跟随鲸群迁徙、记录深海热泉的生命奇观、捕捉珊瑚礁的无声变迁。它讲述了人类与海洋共同命运的故事，也提醒我们：这颗蓝色星球，值得被更好地理解与守护。"
  },
  {
    id: "undercurrent",
    title: "暗涌",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    genres: ["商战", "悬疑", "都市"],
    director: "汤临川",
    actors: ["霍川", "姜晚", "罗正"],
    duration: "48 分钟 / 集",
    episodes: 32,
    updatedAt: "2024-11-30",
    popularity: 8560,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20corporate%20thriller%20poster%20of%20a%20glass%20skyscraper%20boardroom%20at%20night%20with%20figures%20in%20silhouette%20around%20a%20long%20table%2C%20city%20lights%20outside%2C%20deep%20navy%20and%20grey%20tones%20with%20a%20cold%20orange%20accent%2C%20tense%20mood&width=400&height=600&seq=mv-13&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20night%20cityscape%20seen%20through%20a%20glass%20office%20wall%20with%20blurred%20lights%2C%20lone%20figure%20standing%20before%20the%20window%2C%20deep%20blue%20and%20charcoal%20tones%20with%20warm%20orange%20reflections%2C%20cold%20corporate%20atmosphere&width=1600&height=900&seq=mv-13-bd&orientation=landscape",
    tagline: "水面之下，才是真正的较量。",
    description:
      "一家老牌企业在创始人离世后陷入权力真空，各方势力在平静的会议桌下暗流涌动。年轻的继承人被迫在家族、资本与道义之间做出选择，而每一步都可能被水面之下的暗涌吞没。商业博弈，比锋芒更可怕的是沉默。"
  },
  {
    id: "kingdom-of-paper",
    title: "纸上王国",
    type: "动漫",
    region: "日本",
    year: 2023,
    rating: 9.0,
    genres: ["奇幻", "冒险", "治愈"],
    director: "宫下和也",
    actors: ["配音：早见沙织", "配音：花江夏树", "配音：悠木碧"],
    duration: "23 分钟 / 集",
    episodes: 24,
    updatedAt: "2024-10-25",
    popularity: 8940,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20anime%20poster%20of%20a%20child%20reading%20a%20magic%20book%20as%20a%20paper%20world%20unfolds%20around%20them%2C%20folded%20origami%20kingdom%2C%20teal%20and%20navy%20tones%20with%20warm%20orange%20and%20gold%20highlights%2C%20whimsical%20and%20tender&width=400&height=600&seq=mv-14&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20whimsical%20anime%20landscape%20of%20a%20kingdom%20made%20of%20folded%20paper%20and%20floating%20books%2C%20gentle%20ring%20of%20light%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20glow%2C%20dreamy%20storybook%20atmosphere&width=1600&height=900&seq=mv-14-bd&orientation=landscape",
    tagline: "每个孩子合上的书里，都有一个正在等待的王国。",
    description:
      "内向的小女孩在祖父留下的旧书店里，发现了一本会自己翻页的书。翻开书页的瞬间，她跌进了一个由折纸与文字构成的奇幻王国。为了回到现实，她必须帮助王国里的居民找回被遗忘的故事，也在旅程中慢慢找回了说话的勇气。"
  },
  {
    id: "journey-train",
    title: "归途列车",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    rating: 8.5,
    genres: ["剧情", "家庭", "公路"],
    director: "闻人野",
    actors: ["老李:周铁", "父亲:赵大川", "林夏:苏念"],
    duration: "112 分钟",
    updatedAt: "2024-11-12",
    popularity: 7680,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20an%20old%20train%20crossing%20snowy%20countryside%20at%20sunset%2C%20warm%20light%20in%20the%20windows%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20accents%2C%20nostalgic%20and%20tender&width=400&height=600&seq=mv-15&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20an%20old%20train%20winding%20through%20a%20snowy%20countryside%20at%20sunset%2C%20bare%20trees%20and%20distant%20village%2C%20deep%20blue%20dusk%20tones%20with%20warm%20orange%20sky%2C%20quiet%20and%20moving&width=1600&height=900&seq=mv-15-bd&orientation=landscape",
    tagline: "无论走多远，总有一趟车开往家。",
    description:
      "在外打工十年的父亲决定赶在除夕前回家，却因一场大雪被困在一列晚点的绿皮火车上。车厢里挤满了同样归心似箭的陌生人，他们分享食物、交换故事，也分享彼此的牵挂。当列车缓缓驶入熟悉的站台，一段关于回家的旅程有了答案。"
  },
  {
    id: "under-neon",
    title: "霓虹之下",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    genres: ["科幻", "赛博朋克", "悬疑"],
    director: "江离",
    actors: ["凌川", "阮星", "齐越"],
    duration: "126 分钟",
    updatedAt: "2024-11-20",
    popularity: 8340,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cyberpunk%20poster%20of%20a%20rainy%20neon%20lit%20city%20street%20with%20holographic%20signs%20and%20a%20lone%20figure%20in%20a%20coat%2C%20teal%20and%20navy%20tones%20with%20strong%20orange%20and%20pink%20neon%20accents%2C%20futuristic%20mood&width=400&height=600&seq=mv-16&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cyberpunk%20cityscape%20at%20night%20in%20heavy%20rain%20with%20towering%20holographic%20billboards%2C%20flying%20vehicles%20and%20reflective%20streets%2C%20deep%20navy%20and%20teal%20tones%20with%20vivid%20orange%20neon%20glow%2C%20immersive%20and%20high%20detail&width=1600&height=900&seq=mv-16-bd&orientation=landscape",
    tagline: "霓虹照亮了整座城，却照不亮一个人的记忆。",
    description:
      "在一座由数据与霓虹构成的城市里，记忆可以被存储、买卖，甚至被抹去。一名负责回收非法记忆的稽查员，在一次任务中发现了属于自己的、本不该存在的记忆碎片。为了弄清真相，他开始追查一段被整座城市刻意遗忘的过去。"
  },
  {
    id: "between-mountains-and-seas",
    title: "山海之间",
    type: "纪录片",
    region: "中国大陆",
    year: 2023,
    rating: 9.2,
    genres: ["人文", "旅行", "地理"],
    director: "总导演：方野",
    actors: ["解说：沈砚"],
    duration: "50 分钟 / 集",
    episodes: 6,
    updatedAt: "2024-09-30",
    popularity: 8420,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20documentary%20poster%20of%20an%20aerial%20view%20where%20a%20mountain%20range%20meets%20the%20sea%20at%20sunrise%2C%20mist%20in%20the%20valleys%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20sun%2C%20majestic%20and%20serene&width=400&height=600&seq=mv-17&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20aerial%20cinematic%20landscape%20of%20rugged%20mountains%20meeting%20a%20vast%20blue%20sea%20at%20dawn%2C%20layered%20mist%20and%20a%20small%20coastal%20village%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20horizon%2C%20grand%20and%20tranquil&width=1600&height=900&seq=mv-17-bd&orientation=landscape",
    tagline: "山记得所有登过它的人，海记得所有信过它的人。",
    description:
      "摄制组沿中国大陆海岸线行走三千公里，记录生活在山海之间的普通人家。他们中有世代打渔的船老大、守着一座灯塔三十年的老人、在高原上放牧的年轻人。在山与海的交界处，人与土地的关系被讲述得格外动人。"
  },
  {
    id: "silent-snow",
    title: "雪落无声",
    type: "电视剧",
    region: "中国大陆",
    year: 2022,
    rating: 8.4,
    genres: ["年代", "剧情", "家庭"],
    director: "陆时蕴",
    actors: ["白青梅", "顾南山", "陆行舟"],
    duration: "44 分钟 / 集",
    episodes: 28,
    updatedAt: "2024-07-30",
    popularity: 6980,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20of%20a%20snow%20covered%20traditional%20Chinese%20village%20in%20winter%20with%20warm%20lit%20windows%2C%20quiet%20and%20nostalgic%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20lamplight&width=400&height=600&seq=mv-18&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20snowy%20old%20town%20at%20dusk%20with%20smoke%20rising%20from%20chimneys%20and%20soft%20window%20light%2C%20bare%20trees%20and%20low%20hills%2C%20deep%20blue%20winter%20tones%20with%20warm%20orange%20glow%2C%20nostalgic%20atmosphere&width=1600&height=900&seq=mv-18-bd&orientation=landscape",
    tagline: "雪落下的时候，往事就都回来了。",
    description:
      "故事从上世纪八十年代的一座北方小城讲起，围绕一户普通人家的三个孩子展开。他们在时代的浪潮中各自做出选择，有人留守故土，有人远走他乡。多年后一场大雪落下，所有的牵挂与和解，都在无声的雪中悄然完成。"
  },
  {
    id: "fog-detective-agency",
    title: "迷雾侦探社",
    type: "动漫",
    region: "日本",
    year: 2024,
    rating: 8.7,
    genres: ["悬疑", "推理", "轻喜剧"],
    director: "佐藤健一",
    actors: ["配音：神谷浩史", "配音：早见沙织"],
    duration: "24 分钟 / 集",
    episodes: 22,
    updatedAt: "2024-12-03",
    popularity: 8100,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20anime%20mystery%20poster%20of%20a%20foggy%20cobblestone%20street%20with%20vintage%20lanterns%20and%20a%20detective%20agency%20sign%2C%20cozy%20yet%20mysterious%2C%20deep%20navy%20and%20teal%20tones%20with%20warm%20orange%20lamp%20glow&width=400&height=600&seq=mv-19&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20anime%20scene%20of%20a%20foggy%20old%20town%20square%20at%20night%20with%20warm%20lanterns%20and%20a%20small%20detective%20office%2C%20shelves%20of%20books%20and%20case%20files%2C%20deep%20navy%20and%20teal%20tones%20with%20orange%20glow&width=1600&height=900&seq=mv-19-bd&orientation=landscape",
    tagline: "再离奇的谜题，也藏着最普通的人心。",
    description:
      "在一座常年被雾气笼罩的小镇上，藏着一间不起眼的侦探社。社长是个爱喝茶的慢性子，助手是刚毕业、满脑子理论的年轻人。他们接手的案子五花八门，却总能在看似无解的表象下，找到属于普通人的、温暖人心的答案。"
  },
  {
    id: "against-the-light",
    title: "逆光而行",
    type: "电影",
    region: "中国大陆",
    year: 2023,
    rating: 8.0,
    genres: ["剧情", "励志", "运动"],
    director: "何向晨",
    actors: ["林越", "江小雨", "程岸"],
    duration: "118 分钟",
    updatedAt: "2024-08-05",
    popularity: 7020,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20inspirational%20poster%20of%20a%20runner%20silhouette%20on%20a%20hill%20against%20a%20bright%20sunrise%2C%20lens%20flare%20and%20dust%2C%20deep%20navy%20and%20teal%20foreground%20with%20strong%20warm%20orange%20sunlight%2C%20hopeful%20and%20motivating&width=400&height=600&seq=mv-20&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20sunrise%20landscape%20with%20a%20lone%20runner%20on%20an%20open%20road%20toward%20the%20horizon%2C%20golden%20light%20and%20long%20shadows%2C%20deep%20blue%20and%20teal%20tones%20with%20warm%20orange%20sunrise%2C%20hopeful%20atmosphere&width=1600&height=900&seq=mv-20-bd&orientation=landscape",
    tagline: "光在前面，所以只能朝前跑。",
    description:
      "曾因伤病退役的长跑运动员，为了完成母亲未竟的心愿，决定重返赛场。没有团队、没有赞助，他只能一个人在清晨的街道上训练。一个偶然凑成的陪跑小队，让这段孤独的旅程多了温度。当他再次站上起点，比赛的对手早已不是别人。"
  }
];